// extracted by mini-css-extract-plugin
export var hideEditor = "_k0-2";
export var infoIcon = "_k0-3";
export var label = "_k0-1";
export var labelContainer = "_k0-0";
export var readonlyText = "_k0-4";